import React from 'react'
import { Link } from 'react-router-dom'
import Rating from '@material-ui/lab/Rating'

class ProductsAdd extends React.Component {
  state = {
    status: 'AVAILABLE',
    isSaving: false,
    cityData: [],
    hotName: '',
    hotNameAr: '',
    hotPricePerNight: null,
    hotPriceCurrency: '',
    hotPriceCurrencyAr: '',
    hotAddress: '',
    hotAddressAr: '',
    hotLat: null,
    hotLong: null,
    hotEmail: '',
    hotEmailAr: '',
    cityID: '',
    city: '',
    ratings: 3,
    hotTelephoneNo: null,
    customproduct_id: '',
    updating: false,
  }

  changestar = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
    // this.getLonAndLat(this.state.hotAddress)
  }

  onSaveDataBoat = () => {}
  onUpdateDataBoat = () => {}

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Products Name</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="hotName"
                    id="hotName"
                    placeholder="Products Name"
                    onChange={this.handleChange}
                    value={this.state.hotName}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Category</label>
                <div className="col-sm-9">
                  <select
                    name="Category"
                    className="form-control"
                    value={this.state.Category}
                    onChange={this.handleChange}
                  >
                    <option>Category 1</option>
                    <option>Category 2</option>
                    <option>Category 3</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Products SKU</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="hotName"
                    id="hotName"
                    placeholder="Products SKU"
                    onChange={this.handleChange}
                    value={this.state.hotSKU}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Price Currency</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="hotPriceCurrency"
                    id="hotPriceCurrency"
                    placeholder="Price Currency"
                    onChange={this.handleChange}
                    value={this.state.hotPriceCurrency}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Price</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="hotPricePerson"
                    id="hotPriceCperson"
                    placeholder="Price"
                    onChange={this.handleChange}
                    value={this.state.hotPricePerson}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Shop Name</label>
                <div className="col-sm-9">
                  <select
                    name="shopname"
                    className="form-control"
                    value={this.state.shopname}
                    onChange={this.handleChange}
                  >
                    <option>Shop Name 1</option>
                    <option>Shop Name 2</option>
                    <option>Shop Name 3</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Max Qunatity</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="hotEmail"
                    id="hotEmail"
                    placeholder="Max Qunatity"
                    onChange={this.handleChange}
                    value={this.state.hotEmail}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Stock</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="hotEmailAr"
                    id="hotEmailAr"
                    placeholder="Stock"
                    onChange={this.handleChange}
                    value={this.state.hotEmailAr}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Shop Ratings</label>
                <div className="col-sm-9">
                  {/* <select
                    type="number"
                    className="form-control"
                    name="ratings"
                    id="ratings"
                    placeholder="Products ratings"
                    onChange={this.handleChange}
                    value={this.state.ratings}
                  >
                    <option value="">Select Ratings Star</option>
                    <option value={1} >1</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                    <option value={5}>5</option>
                  </select> */}
                  <Rating
                    name="simple-controlled"
                    value={this.state.ratings}
                    onChange={this.changestar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <select
                    name="status"
                    className="form-control"
                    value={this.state.status}
                    onChange={this.handleChange}
                  >
                    <option
                      value="AVAILABLE"
                      name="AVAILABLE"
                    >
                      AVAILABLE
                    </option>
                    <option
                      value="NOT_AVAILABLE"
                      name="NOT_AVAILABLE"
                    >
                      NOT AVAILABLE
                    </option>
                    <option
                      value="BUSY"
                      name="BUSY"
                    >
                      BUSY
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="row">
            <div className="col-md-12">
              <div className="form-group row">
                <label className="col-sm-2 col-form-label">Room Types</label>
                <div className="col-sm-10">
                  <div className="p-20 z-depth-right-1 waves-effect " data-toggle="tooltip" data-placement="top" title="" data-original-title="Service List">
                    <div className="row">
                      {
                        this.state.room_type_list !== undefined &&
                          this.state.room_type_list !== null &&
                          this.state.room_type_list !== [] &&
                          this.state.room_type_list.length > 0 ? (
                            this.state.room_type_list.map(room_type =>
                              <div className=" col-sm-4" key={room_type.id}>
                                <div className="checkbox-fade fade-in-primary">
                                  <label>
                                    <input type="checkbox" id={"airways_room_type_" + room_type.id} value={room_type.id} onChange={this.changeRoomTypesSelection} defaultChecked />
                                    <span className="cr">
                                      <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span>{room_type.name}</span>
                                  </label>
                                </div>
                              </div>
                            )) : ""
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="form-group row">
                <label className="col-sm-2 col-form-label">Activities</label>
                <div className="col-sm-10">
                  <div className="p-20 z-depth-right-1 waves-effect " data-toggle="tooltip" data-placement="top" title="" data-original-title="Activities List">
                    <div className="row">
                      {
                        this.state.activity_list !== undefined &&
                          this.state.activity_list !== null &&
                          this.state.activity_list !== [] &&
                          this.state.activity_list.length > 0 ? (
                            this.state.activity_list.map(activities =>
                              <div className=" col-sm-4" key={activities.id}>
                                <div className="checkbox-fade fade-in-primary">
                                  <label>
                                    <input type="checkbox" id={"airways_activities_" + activities.id} value={activities.id} onChange={this.changeActivitiesSelection} />
                                    <span className="cr">
                                      <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span>{activities.name}</span>
                                  </label>
                                </div>
                              </div>
                            )) : ""
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className="row float-right p-3">
            {this.state.updating ? (
              <button
                className="btn btn-grd-disabled mr-2"
                onClick={this.onUpdateDataBoat}
              >
                Update
              </button>
            ) : (
              <button
                onClick={this.onSaveDataBoat}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
            {/* <button onClick={this.onSaveDataBoat} className="btn btn-grd-disabled mr-2"><i className="icofont icofont-save"></i> Save</button> */}

            <Link
              to={'/customproduct'}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default ProductsAdd
